import TicketPhotoItem from '@/components/ticketDetail/components/shared/parkinglotPhoto/item'

import type { SliderOptions } from '@/shared/components/slider/types/sliderOptions'
import SliderView from '@/shared/components/slider/view'
import type { SlideItem } from '@/shared/components/slider/view'

interface ParkinglotPhotosProps {
  options: SliderOptions
  items: SlideItem[]
}

const ParkinglotPhotoList = ({ options, items }: ParkinglotPhotosProps) => (
  <div className="mb-6">
    <SliderView options={options} items={items} slideComponent={TicketPhotoItem} id="#layer2" />
  </div>
)

export default ParkinglotPhotoList
